if (typeof window !== 'undefined' && typeof window.global === 'undefined') {
    window.global = window;
}
